<script lang="ts">
  import axios, { AxiosError } from "axios";
  import AuthForm from "./AuthForm.svelte";
  import { t } from "../../../../core";
  import Input from "../../../elements/Input.svelte";
  import FormErrors from "../../../elements/FormErrors.svelte";
  import { passwordCheck } from "./password-check";
  import { getParameterByName } from "./helpers";

  export let title: string;
  export let description: string;
  export let submit: string;
  export let endpoint: string;

  let password: string = "";
  let confirmPassword: string = "";

  let errorMessage: string = "";
  let isLoading: boolean = false;
  let isDisabled: boolean = false;
  let isErrorShowing: boolean = false;

  const secretKey = getParameterByName("sc");

  function updatePasswordError() {
    const { message } = passwordCheck(password, confirmPassword);
    errorMessage = message;
  }

  function submitForm() {
    errorMessage = "";
    isLoading = true;
    isErrorShowing = true;

    const { isValid, message } = passwordCheck(password, confirmPassword);

    if (isValid === false) {
      errorMessage = message;
      isLoading = false;
      return;
    }

    axios
      .post(endpoint, {
        secretKey,
        password,
        confirmPassword,
      })
      .then(() => (window.location.href = "/"))
      .catch((err: AxiosError) => (errorMessage = err?.response?.data))
      .finally(() => (isLoading = false));
  }
</script>

<AuthForm
  {title}
  {description}
  {submit}
  {isLoading}
  {isDisabled}
  on:click={submitForm}
>
  <Input
    type="password"
    name="userpassword"
    placeholder={t("General.Password.Title")}
    on:blur={updatePasswordError}
    bind:value={password}
  />

  <Input
    type="password"
    name="userconfirmpassword"
    placeholder={t("General.RepeatPassword.Title")}
    on:blur={updatePasswordError}
    bind:value={confirmPassword}
  />

  {#if isErrorShowing && errorMessage}
    <FormErrors {errorMessage} />
  {/if}
</AuthForm>
